module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_2.9e874d92.png";